import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs';
import { LookupModel } from '../../../../models/common/lookup.model';
import { BaseUnsubscribeComponent } from '../../../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../../../shared-new/services/toast.service';
import { StudiesFacade } from '../../../../shared-new/store/studies/studies.facade';

@Component({
  selector: 'app-document-type-modal',
  templateUrl: './document-type-modal.component.html',
  styleUrls: ['./document-type-modal.component.scss'],
})
export class DocumentTypeModalComponent
  extends BaseUnsubscribeComponent
  implements OnInit
{
  studyFileDocTypes$ = this.studyFacade.studyFileDocTypes$;
  docTypes: LookupModel[];

  @Input() public data: any;
  constructor(
    private studyFacade: StudiesFacade,
    public modal: NgbActiveModal,
    private toastService: ToastService
  ) {
    super();
  }

  ngOnInit(): void {
    this.studyFacade.loadStudyFileDocTypes(this.data.isReport);
    this.attachEvents();
  }

  private attachEvents() {
    this.studyFileDocTypes$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.docTypes = response.map((res) => {
          const lookup = new LookupModel();
          lookup.id = res.id;
          lookup.name = res.name;
          lookup.altName = res.altName;
          if (res.id === this.data?.docTypeId) {
            lookup.selected = true;
          }
          return lookup;
        });
      });
  }

  closePopup(): void {
    this.modal.close(JSON.stringify(this.data));
  }

  SelectRow(document: LookupModel) {
    this.docTypes = this.docTypes.map((doc) => {
      doc.selected = false;
      return doc;
    });
    document.selected = true;
  }
  assign() {
    const selectedDoc = this.docTypes.filter((x) => x.selected === true)[0];
    this.data.docTypeId = selectedDoc.id;
    this.data.docTypeName = selectedDoc.name;
    this.closePopup();
  }
  Cancel() {
    this.docTypes = this.docTypes.map((doc) => {
      doc.selected = false;
      return doc;
    });
    this.modal.dismiss();
  }
  isDisabled(): boolean {
    const doc = this.docTypes?.filter((x) => x.selected === true);
    return doc?.length === 0;
  }
}
